import { render, staticRenderFns } from "./TeOfficialNav.vue?vue&type=template&id=6470eea4&"
import script from "./TeOfficialNav.vue?vue&type=script&lang=ts&"
export * from "./TeOfficialNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports